"use client"

import { Star } from "@/lib/icons"
import { Button } from "@/components/ui/button"

interface StarRatingProps {
  rating: number
  onRatingChange: (rating: number) => void
  size?: "sm" | "md" | "lg"
}

export function StarRating({ rating, onRatingChange, size = "md" }: StarRatingProps) {
  const sizes = {
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-5 w-5",
  }

  return (
    <div className="flex gap-1 px-0">
      {[1, 2, 3, 4, 5].map((star) => (
        <Button
          key={star}
          variant="ghost"
          size="sm"
          className="p-0 h-auto w-auto hover:bg-transparent"
          onClick={() => onRatingChange(rating === star ? 0 : star)}
          title={`Rate ${star} star${star !== 1 ? "s" : ""}`}
        >
          <Star
            className={`${sizes[size]} transition-colors ${
              star <= rating ? "fill-yellow-400 text-yellow-400" : "text-muted-foreground hover:text-yellow-300"
            }`}
          />
        </Button>
      ))}
    </div>
  )
}
